// Print sizes of the AI photo editor's document photos, keyed by the photo's saved `photoSize`. The defaults match the editor's own
// sizes (SIZE_DIMS in GenerateImage). Settings → print size lets the user change them (saved in user.settings.printSizes under wKey/hKey),
// and the print window's first quick-add row follows the photo in the slider's centre. Passport and dual keep their own passportSingle*/passportDual* sizes.
const entry = (key, labelKey, w, h) => ({ key, labelKey, wKey: `${key}W`, hKey: `${key}H`, defaultW: w, defaultH: h });

export const PHOTO_PRINT_SIZES = [
    entry('bd_epassport', 'abbrEPass', 25, 30),
    entry('bd_birth', 'abbrBirth', 35, 45),
    entry('visa_2x2', 'abbrVisa', 50.8, 50.8),
    entry('visa_35x45', 'abbrVisa', 35, 45),
    entry('visa_40x60', 'abbrVisa', 40, 60),
    entry('visa_40x50', 'abbrVisa', 40, 50),
    entry('visa_40x40', 'abbrVisa', 40, 40),
    entry('visa_50x50', 'abbrVisa', 50, 50),
    entry('visa_50x70', 'abbrVisa', 50, 70),
    entry('visa_33x48', 'abbrVisa', 33, 48),
    entry('visa_35x50', 'abbrVisa', 35, 50),
    entry('visa_36x47', 'abbrVisa', 36, 47),
    entry('visa_38x48', 'abbrVisa', 38, 48),
    entry('visa_50x60', 'abbrVisa', 50, 60),
];

export const PHOTO_PRINT_DEFAULTS = Object.fromEntries(PHOTO_PRINT_SIZES.flatMap((s) => [[s.wKey, s.defaultW], [s.hKey, s.defaultH]]));

// bd_visa is the general visa tile, a 35×45 photo. Sizes outside the list (passport, dual, Studio prints) return null.
export const photoPrintSizeOf = (photoSize) => PHOTO_PRINT_SIZES.find((s) => s.key === (photoSize === 'bd_visa' ? 'visa_35x45' : photoSize)) ?? null;

export const photoPrintDims = (size, printSizes = {}) => ({ w: printSizes[size.wKey] || size.defaultW, h: printSizes[size.hKey] || size.defaultH });
